import angular from 'angular';
import ngRoute from 'angular-route';
import CSMCommonWeb from 'csm-common-web';
import entitiesAdminData from './data/EntityAdminListItem';
import entitiesAdminTemplate from './templates/entitiesAdmin.template.html';
import addChangeGroupDialog from './dialogs/AddChangeGroupDialog/AddChangeGroupDialog';
import addChangeTagDialog from '../../com/AddChangeTagDialog/AddChangeTagDialog';
import groupsListDialog from './dialogs/GroupsListDialog/GroupsListDialog';
import namesListDialog from './dialogs/NamesListDialog/NamesListDialog';
import makeMemberDialog from './dialogs/MakeMemberDialog/MakeMemberDialog';
import addChangeSystemLoginDialog from '../../com/AddChangeSystemLoginDialog/AddChangeSystemLoginDialog';
import CSMBooksWeb from '../../../CSMBooksWeb';
import { groupsEntityContentComponent, GroupsEntityController } from './groups';
import { namesEntityContentComponent, NamesEntityController } from './names';
import {
  statusesEntityContentComponent,
  StatusesEntityController
} from './statuses';
import './entitiesAdmin.css';
import '../../dom/dom.css';

export default angular
  .module('entitiesAdmin', [
    CSMCommonWeb,
    ngRoute,
    'ui.grid',
    entitiesAdminData,
    addChangeGroupDialog,
    addChangeSystemLoginDialog,
    groupsListDialog,
    namesListDialog,
    makeMemberDialog,
    CSMBooksWeb,
    'books.dialogs.entities.mergeEntityDialog',
    addChangeTagDialog
  ])
  /*****************************************************************************
   * Component: entityAdmin *
   *
   * The following will be bound from the component usage:
   *   appFlags        Array of application flags
   *   hideAsbCard     Boolean indication to hide/show the ASB Card Year column in
   *                   the Names grid and the Make ASB Card holder button.
   *   hideStatuses    Boolean indication to exclude the statuses route and
   *                   content.
   *   studentIdOnly   Boolean indication to display just the student ID number in
   *                   the Student ID column.
   *****************************************************************************/
  .component('entitiesAdmin', {
    template: entitiesAdminTemplate,
    controller: 'EntityAdminController',
    bindings: {
      appFlags: '=',
      hideAsbCard: '=',
      hideStatuses: '=',
      studentIdOnly: '='
    }
  })
  .controller('EntityAdminController', [
    '$location',
    function ($location) {
      /*****************************************************************************
       * Properties
       *****************************************************************************/
      /** Instance reference. */ var mThis = this;

      mThis.$onInit = function () {
        /*---------------------------*/
        /* Route navigation options. */
        /*---------------------------*/
        var mNames = { display: 'Names', active: true, route: '/' };
        var mGroups = { display: 'Groups', active: false, route: '/groups/' };
        var mStatuses = {
          display: 'Statuses',
          active: false,
          route: '/statuses/'
        };

        /*---------------------*/
        /* Add default routes. */
        /*---------------------*/
        mThis.options = [mNames, mGroups];

        /*-----------------------------------------------------*/
        /* Include the Statuses route based on attribute flag. */
        /*-----------------------------------------------------*/
        if (!mThis.hideStatuses) mThis.options.push(mStatuses);

        /*-----------*/
        /* App Flags */
        /*-----------*/
        /** Restrict Individuals. */ mThis.restrictIndividuals =
          mThis.appFlags.restrictIndividuals;
        /** Restrict Roles.    */ mThis.restrictPTARoles =
          mThis.appFlags.restrictPTARoles;
        /** Restrict Security. */ mThis.restrictSecurity =
          mThis.appFlags.restrictSecurity;

        /*****************************************************************************
         * onOption */
        /**
         * Nav buttons click handler. Clears the former active option and navigates to
         * the route for the passed option.
         *
         * @param   option  Option to make active
         *****************************************************************************/
        mThis.onOption = function (option) {
          /*-----------------------------*/
          /* Maintain the active option. */
          /*-----------------------------*/
          mThis.activeOption = option;

          /*----------------------------------------*/
          /* Ignore if the option is already active */
          /*----------------------------------------*/
          if (option.active) return;

          /*------------------------------------------*/
          /* Set active flag on user selection and    */
          /* disable on the other navigation buttons. */
          /*------------------------------------------*/
          if (mThis.options)
            mThis.options.forEach(function (c) {
              c.active = false;
            });

          option.active = true;

          /*--------------------*/
          /* Navigate to route. */
          /*--------------------*/
          $location.path(option.route);
        };

        /*-------------------------------------------------------------*/
        /* Highlight the appropriate option based on the current route */
        /*-------------------------------------------------------------*/
        mThis.onOption(
          mThis.options
            .filter(function (option) {
              return option.route == $location.path();
            })
            .shift()
        );
      };
    }
  ])
  .component('groupsEntityContent', groupsEntityContentComponent)
  .controller('GroupsEntityController', GroupsEntityController)
  .component('namesEntityContent', namesEntityContentComponent)
  .controller('NamesEntityController', NamesEntityController)
  .component('statusesEntityContent', statusesEntityContentComponent)
  .controller('StatusesEntityController', StatusesEntityController).name;
